import cn from "classnames";
import Styles from "./Footer.module.scss";
import { BuildInfo } from "src/components/compounds/BuildInfo/BuildInfo";

export const FooterContent = ({ style }: { style: string }) => (
  <div className={cn(Styles.footerContainer, style)}>
    <div className="footerLeft">&nbsp;</div>
    <div className={Styles.footerRight}>
      <BuildInfo />
    </div>
  </div>
);
